import { render, staticRenderFns } from "./sushiCard.vue?vue&type=template&id=637266da&scoped=true"
import script from "./sushiCard.vue?vue&type=script&lang=js"
export * from "./sushiCard.vue?vue&type=script&lang=js"
import style0 from "./sushiCard.vue?vue&type=style&index=0&id=637266da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637266da",
  null
  
)

export default component.exports